import { Container, i18n, utils } from "@common";
import { permissionEmailTemplate, permissionReport, permissionStudentManagement, permissionGroupManagement } from "../constant";
import { routerPaths } from '../tool';
import "./index.less";
const Dashboard = () => {

    const handleBackClick = (state) => {
        switch (state) {
            case "StudentManagement":
                permissionStudentManagement.read && utils.redirectTo(routerPaths.studentManagement);
                break;
            case "GroupManagement":
                permissionGroupManagement.read && utils.redirectTo(routerPaths.groupManagement);
                break;
            case "Reporting":
                permissionReport.read && utils.redirectTo(routerPaths.reporting);
                break;
            case "EmailTemplate":
                permissionEmailTemplate.read && utils.redirectTo(routerPaths.emailTemplate);
                break;
        }
    };
    return (
        <div className="div-page-theme">
            {permissionStudentManagement.read && <Container.Section className='container-dashboard' onClick={() => handleBackClick('StudentManagement')}>
                <div className="image student heardTitle">
                    <div className="dashboard-card-title" data-tooltip="ifneed" style={{ disabled: 'true' }}>{i18n.get('CIS_Admin_Dashboard_StudentManagement_Entry')}</div>
                    <div className="icon fia-arrow-right-subnav"></div>
                </div>
            </Container.Section>}
            {permissionGroupManagement.read && <Container.Section className='container-dashboard' onClick={() => handleBackClick('GroupManagement')}>
                <div className="image group heardTitle">
                    <div className="dashboard-card-title" data-tooltip="ifneed" style={{ disabled: 'true' }}>{i18n.get('CIS_Admin_Dashboard_GroupManagement_Entry')}</div>
                    <div className="icon fia-arrow-right-subnav"></div>
                </div>
            </Container.Section>}
            {permissionReport.read && <Container.Section className='container-dashboard' onClick={() => handleBackClick('Reporting')}>
                <div className="image reporting heardTitle">
                    <div className="dashboard-card-title" data-tooltip="ifneed">{i18n.get('CIS_Admin_Dashboard_Reporting_Entry')}</div>
                    <div className="icon fia-arrow-right-subnav"></div>
                </div>
            </Container.Section>}
            {permissionEmailTemplate.read && <Container.Section className='container-dashboard' onClick={() => handleBackClick('EmailTemplate')}>
                <div className="image email heardTitle">
                    <div className="dashboard-card-title" data-tooltip="ifneed">{i18n.get('CIS_Admin_Dashboard_EmailTemplate_Entry')}</div>
                    <div className="icon fia-arrow-right-subnav"></div>
                </div>
            </Container.Section>}
        </div>
    );
};

export default Dashboard;